module.exports = __webpack_public_path__ + "media/organizations/siemens-62a70681.svg";